import { Heading } from "../../global/styles/styles";

const Score = ({$size, score, player}) => {
    return (
        <Heading $size={$size}>{player ? player : "Score"}: {score}</Heading>
    )
}

export default Score;